import React from "react";
import { NotFound } from "pages/login/NotFound";
import { i18n } from "app/i18n/i18n";
import menuFilters from "redux/slices/data/menuFilters.json";

export const MenuAlt = (match) => {
  const lang = i18n.getLanguage();
  if (!isValidMenuPath(match, lang)) return <NotFound match={match} />;

  return null;
};

export const isValidMenuPath = (path, lang) =>
  Object.keys(path).reduce((acc, key) => {
    const filter = path[key];
    if (!filter) return acc;
    if (!menuFilters[filter]) console.error("Invalid menu item:", filter);
    return acc && !!menuFilters[filter];
  }, true);
